import React from 'react';

import DashboardView from 'views/Dashboard';
import ScheduleView, { scheduleRoutes } from 'views/Schedule';
import { ListEngineersView, engineerRoutes } from 'views/Engineers';
import { ListJobTypesView, jobTypeRoutes } from 'views/JobTypes';
import { ListSkillsView, skillRoutes } from 'views/Skills';
import { ListPatchesView } from 'views/Patches';
import { ListCapacityTypesView } from 'views/CapacityTypes';
import { ListReserveCapacityView } from 'views/ReserveCapacity';
import {
  scheduleDomain,
  engineerDomain,
  patchDomain,
  jobTypeDomain,
  skillDomain,
  jobDomain,
  capacityTypeDomain,
  reserveCapacityDomain
} from 'models';
import { ListJobsView } from 'views/Jobs';
import appointmentsRoutes from 'views/Appointments/routes';

export interface NavigationSection {
  label: string;
  routes: NavigationRoute[];
}

export interface NavigationRoute {
  to: string;
  label?: string;
  component: (...args: any) => React.ReactElement | null;
  exact?: boolean;
  routes?: NavigationRoute[];
}

const navigationSections = (
  hasRoleAvailabilityReserveCapacityRead: boolean
): NavigationSection[] => [
  {
    label: '',
    routes: [
      {
        to: '/dashboard',
        label: 'Dashboard',
        component: DashboardView
      }
    ]
  },
  {
    label: 'Dispatch',
    routes: [
      {
        to: `/dashboard/${scheduleDomain.urlPath}`,
        label: scheduleDomain.label,
        component: ScheduleView,
        routes: scheduleRoutes
      },
      {
        to: `/dashboard/${jobDomain.urlPath}`,
        label: jobDomain.label,
        component: ListJobsView
      },
      ...appointmentsRoutes
    ]
  },
  {
    label: 'Planning',
    routes: [
      {
        to: `/dashboard/${engineerDomain.urlPath}`,
        label: engineerDomain.label,
        component: ListEngineersView,
        routes: engineerRoutes()
      },
      {
        to: `/dashboard/${patchDomain.urlPath}`,
        label: patchDomain.label,
        component: ListPatchesView
      },
      {
        to: `/dashboard/${jobTypeDomain.urlPath}`,
        label: jobTypeDomain.label,
        component: ListJobTypesView,
        routes: jobTypeRoutes()
      },
      {
        to: `/dashboard/${skillDomain.urlPath}`,
        label: skillDomain.label,
        component: ListSkillsView,
        routes: skillRoutes
      },
      ...(hasRoleAvailabilityReserveCapacityRead
        ? [
            {
              to: `/dashboard/${capacityTypeDomain.urlPath}`,
              label: capacityTypeDomain.label,
              component: ListCapacityTypesView
            },
            {
              to: `/dashboard/${reserveCapacityDomain.urlPath}`,
              label: reserveCapacityDomain.label,
              component: ListReserveCapacityView
            }
          ]
        : [])
    ]
  }
];

export default navigationSections;
